import { Component, ComponentRef, EventEmitter, Input, OnChanges, OnDestroy, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { SnapshotDynamicScorecardComponent } from './dynamic.component';
import { SnapshotScorecardService } from './snapshot-scorecard.service';
import { SnapshotDynamicComponentDirective } from './snapshot.directive';

@Component({
  selector: 'app-snapshot-scorecard',
  template: `
    <app-closing-side-drawer [title]="'COMMON.TERMS.SNAPSHOT_REPORT' | translate">
      <app-side-drawer-title-actions></app-side-drawer-title-actions>
      <app-side-drawer-content>
        <ng-template appSnapshotDynamicComponent></ng-template>
      </app-side-drawer-content>
    </app-closing-side-drawer>
  `,
})
export class SnapshotScorecardComponent implements OnChanges, OnDestroy {
  @Input() accountGroupId: string;
  @Input() partnerId: string;
  @Input() trackingCategory: string;
  @Input() trigger: any;
  @Input() showEditButton: boolean;

  @Output() refreshReportClickedEvent: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild(SnapshotDynamicComponentDirective, { static: true })
  snapshotDynamicComponent: SnapshotDynamicComponentDirective;
  componentRef: ComponentRef<any>;
  subscriptions: Subscription[] = [];

  constructor(private snapshotScorecardService: SnapshotScorecardService) {}

  ngOnChanges(): void {
    this.componentRef = this.snapshotScorecardService.createComponent(
      SnapshotDynamicScorecardComponent,
      this.snapshotDynamicComponent,
    );
    this.componentRef.instance.accountGroupId = this.accountGroupId;
    this.componentRef.instance.partnerId = this.partnerId;
    this.componentRef.instance.trackingCategory = this.trackingCategory;
    this.componentRef.instance.showEditButton = this.showEditButton;
    this.subscriptions.push(
      this.componentRef.instance.refreshReportClickedEvent.subscribe(() => this.refreshClicked()),
    );
  }

  refreshClicked(): void {
    this.refreshReportClickedEvent.emit();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
